import {
  FETCH_TLOG_DATA_REQUEST,
  FETCH_TLOG_DATA_SUCCESS,
  FETCH_TLOG_DATA_FAILURE,
} from "./types";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const data360LiveTlogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TLOG_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_TLOG_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_TLOG_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default data360LiveTlogReducer;
